import {AppState} from "../store";

export const getVolumeInventorySearchPageFilter = (state: AppState) => state.volumeInventorySearchPage.filter
